import type { NftSearchItem } from "@anaconda/core/nft/search/types"
import { cn } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { ErrorBoundary } from "react-error-boundary"
import { useUserOwnedNft } from "../hooks/use-user-owned-nft"
import { ListingDialogReatom } from "../order/listing-dialog/listing-dialog.reatom"
import { BuyButtonReatom as BuyButton } from "../order/widget/actions/buy.reatom"
import { shouldShowBuyCta } from "../should-show-buy-cta"

interface Props {
  nftPreview: NftSearchItem
}

export function Action({ nftPreview }: Props) {
  return (
    <ErrorBoundary fallback={<ActionButtons nftPreview={nftPreview} />}>
      <ActionButtons nftPreview={nftPreview} />
    </ErrorBoundary>
  )
}

const ActionButtons = reatomComponent<Props>(({ nftPreview }) => {
  const { userOwnedNft } = useUserOwnedNft(nftPreview)

  if (userOwnedNft) {
    // Already listed (ours or ME) — no second listing CTA
    return !nftPreview.price ? (
      <ListingDialogReatom
        trigger={{ className: "max-w-full text-wrap" }}
        nft={nftPreview}
      />
    ) : null
  }

  if (!shouldShowBuyCta(nftPreview, userOwnedNft)) {
    return null
  }

  return (
    <BuyButton
      className={cn("relative")}
      nft={nftPreview}
      collectionName={undefined}
    />
  )
}, "NftPreviewActionButtons")
